/*****************************************************************************/
/*  File Name: timeRangeCalculations.js                                      */
/*  Date:      June 27, 2023                                                 */
/*  Author:    Christopher Cressman                                          */
/*  Purpose:   This is the bar that will show the users the calculations 
/*             based on their selection on the timeRangeBar
/*
/*****************************************************************************/

import React from 'react';
import { withTranslation } from 'react-i18next';

//import styles from './styles/roi.module.scss';
import { Grid } from '@mui/material';
import { useROIContext } from '../../context/roiContext';
import { convertToCurrency } from '../../functions/convertCurrency';
import styles from './styles/roi.module.scss';

function ConsumerTimeRangeCalculations({ t }) {
  //Load all of the default component varaibles

  const { selectedTimeBreakdown, consumerPracticeGrowthRevenue, consumerTreatmentGrowthCost, consumerTreatmentGrowthProfit } = useROIContext();

  return (
    <Grid item xs={12} container className={styles.priceGrid} alignItems='center' alignContent='center' justifyContent='center'>
      <Grid item xs={4}>
        <Grid item xs={12} className={styles.title}>
          Potential {selectedTimeBreakdown} Practice Revenue
        </Grid>
        <Grid item xs={12} className={styles.value}>
          ${convertToCurrency(consumerPracticeGrowthRevenue)}
        </Grid>
      </Grid>
      <Grid item xs={4}>
        <Grid item xs={12} className={styles.title}>
          Potential Total {selectedTimeBreakdown} Costs
        </Grid>
        <Grid item xs={12} className={styles.value}>
          ${convertToCurrency(consumerTreatmentGrowthCost)}
        </Grid>
      </Grid>
      <Grid item xs={4}>
        <Grid item xs={12} className={styles.title}>
          Potential Total {selectedTimeBreakdown}
          <br /> Profit
        </Grid>
        <Grid item xs={12} className={styles.value}>
          ${convertToCurrency(consumerTreatmentGrowthProfit)}
        </Grid>
      </Grid>
    </Grid>
  );
}

export default withTranslation()(ConsumerTimeRangeCalculations);
